import SectionJoinStories from './SectionJoinStories';

export default SectionJoinStories;
